<header class="page-header">
    <h1 class="page-header__title">
        {{ 'authentication.login.title' | translate }}<br />{{ 'common.title' | translate }}
    </h1>
</header>
@for (message of messages; track message) {
    <p-message class="auth-message" [severity]="message.severity">{{ message.detail }}</p-message>
}
<form class="form-grid" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <div class="form-field">
        <label for="login-email" class="form-field__label form-field__label--required">{{
            'authentication.login.form.email' | translate
        }}</label>
        <p-iconfield>
            <p-inputicon styleClass="ms ms-alternate_email" />
            <input
                id="login-email"
                [placeholder]="'authentication.common.placeholder.email' | translate"
                type="text"
                formControlName="email"
                autocomplete="off"
                pInputText
                [fluid]="true" />
        </p-iconfield>
        @if (f.email.touched && f.email.errors?.required) {
            <small class="p-error">{{ 'authentication.login.validation.requiredEmail' | translate }}</small>
        }
        @if (f.email.touched && f.email.errors?.email) {
            <small class="p-error">{{ 'authentication.login.validation.invalidEmail' | translate }}</small>
        }
    </div>
    <div class="form-field">
        <label for="login-password" class="form-field__label form-field__label--required">{{
            'authentication.login.form.password' | translate
        }}</label>
        <p-iconfield>
            <p-inputicon styleClass="ms ms-key" />
            <input
                id="login-password"
                [placeholder]="'authentication.common.placeholder.password' | translate"
                type="password"
                formControlName="password"
                autocomplete="off"
                pInputText
                [fluid]="true" />
        </p-iconfield>
        @if (f.password.touched && f.password.errors?.required) {
            <small class="p-error">{{ 'authentication.login.validation.requiredPassword' | translate }}</small>
        }
        <a routerLink="/auth/forgot-password" class="text-color-secondary text-sm w-max">
            {{ 'authentication.login.forgotPassword' | translate }}
        </a>
    </div>
    <p-button
        type="submit"
        [loading]="loading"
        [label]="'authentication.login.form.button' | translate"
        [fluid]="true"
        data-testid="login-submit" />
</form>
@if (config.registerAllowed) {
    <p class="text-color-secondary mt-4 text-sm">
        {{ 'authentication.login.registerPrompt' | translate }}
        <a routerLink="/auth/register" [queryParams]="registerParams" class="text-primary font-medium ml-1">
            {{ 'authentication.login.registerLink' | translate }}</a
        >
    </p>
}
